var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('AccountIsActivatedCanNotDelete',{ref:"accountIsActivatedCanNotDelete"}),_c('Waiting',{ref:"waiting"}),_c('DeleteAccountSuccess',{ref:"deleteAccountSuccess"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }